export function convFromUtc(dtUtcIso, tzName = "Europe/Lisbon") {
    if (!dtUtcIso) {
        throw new Error("dtUtcIso obrigatório");
    }

    const dtUtc = new Date(dtUtcIso);

    if (isNaN(dtUtc.getTime())) {
        throw new Error(`Datetime inválido: ${dtUtcIso}`);
    }

    // hora local
    const hhmm = new Intl.DateTimeFormat("pt-PT", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: tzName
    }).format(dtUtc);

    // data local
    const dataStr = new Intl.DateTimeFormat("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: tzName
    }).format(dtUtc);

    return {
        hhmm,
        dataStr
    };
}

function getTimeZoneOffsetMs(dateUtc, tzName) {
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: tzName,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hourCycle: "h23"
    }).formatToParts(dateUtc);

    const map = Object.fromEntries(parts.map(p => [p.type, p.value]));

    const asUtc = Date.UTC(
        Number(map.year),
        Number(map.month) - 1,
        Number(map.day),
        Number(map.hour),
        Number(map.minute),
        Number(map.second)
    );

    return asUtc - dateUtc.getTime();
}

export function convToUtc(dataStr, hhmm, tzName = "Europe/Lisbon") {
    const [dd, mm, yyyy] = dataStr.split("/").map(Number);
    const [hh, min] = hhmm.split(":").map(Number);

    let dtUtc = new Date(Date.UTC(yyyy, mm - 1, dd, hh, min, 0));

    let offsetMs = getTimeZoneOffsetMs(dtUtc, tzName);
    dtUtc = new Date(Date.UTC(yyyy, mm - 1, dd, hh, min, 0) - offsetMs);

    // segunda passada para corrigir mudança de offset em DST/virada
    offsetMs = getTimeZoneOffsetMs(dtUtc, tzName);
    dtUtc = new Date(Date.UTC(yyyy, mm - 1, dd, hh, min, 0) - offsetMs);

    return {
        hhmmUtc: dtUtc.toISOString().slice(11, 16),
        dataUtcStr: new Intl.DateTimeFormat("pt-PT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            timeZone: "UTC"
        }).format(dtUtc),
        isoUtc: dtUtc.toISOString()
    };
}